"use client"

import { useState } from "react"
import { faq } from "@/app/content/landing"

export function FaqList() {
  const [openId, setOpenId] = useState<string | null>(faq[0].id)

  return (
    <div className="divide-y divide-line border-y border-line">
      {faq.map((item) => {
        const open = openId === item.id
        return (
          <div key={item.id}>
            <button
              type="button"
              className="flex w-full cursor-pointer items-center justify-between gap-6 py-5 text-left"
              aria-expanded={open}
              onClick={() => setOpenId(open ? null : item.id)}
            >
              <span className="text-base font-medium sm:text-lg">{item.question}</span>
              <span className="grid size-8 shrink-0 place-items-center rounded-full bg-surface text-lg" aria-hidden="true">
                {open ? "–" : "+"}
              </span>
            </button>
            {open ? (
              <p className="max-w-3xl pb-5 text-sm leading-relaxed text-muted sm:text-base">
                {item.answer}
              </p>
            ) : null}
          </div>
        )
      })}
    </div>
  )
}
